import { useTranslation } from '@thoughtspot/i18n';
import { useState } from 'react';
import { InvitedUser } from './invite-users.interface';

export const useInvitedUsersState = (
    onEmailAddAsync: (user: string) => Promise<any>,
) => {
    const { t } = useTranslation();
    const [invitedUsers, setInvitedUsers] = useState<InvitedUser[]>([]);

    const addInvitedUser = async (user: string) => {
        const newInvitedUsers = [...invitedUsers];
        const userIndex = newInvitedUsers.findIndex(
            item => item.address === user,
        );
        if (userIndex === -1) {
            const newUser: InvitedUser = {
                address: user,
            };
            try {
                await onEmailAddAsync(user);
            } catch (error) {
                if (error.status === 409) {
                    newUser.errorMessage = t(
                        'homehub.invite_others.email_exists',
                    );
                }
            } finally {
                newInvitedUsers.push(newUser);
                setInvitedUsers(newInvitedUsers);
            }
        }
    };

    const removeInvitedUser = (user: string) => {
        const newInvitedUsers = [...invitedUsers];
        const userIndex = newInvitedUsers.findIndex(
            item => item.address === user,
        );
        if (userIndex > -1) {
            newInvitedUsers.splice(userIndex, 1);
        }
        setInvitedUsers(newInvitedUsers);
    };
    const resetInvitedUsers = () => setInvitedUsers([]);

    return {
        invitedUsers,
        addInvitedUser,
        removeInvitedUser,
        resetInvitedUsers,
    };
};

export const useInviteDescriptionState = () => {
    const [description, setDescription] = useState('');

    const updateDescription = (desc: string) => {
        setDescription(desc);
    };

    return {
        description,
        updateDescription,
    };
};
